import React from 'react';

import styles from './SectionComplexView.module.scss';

type SectionComplexViewProps = {
  title: string;
  children: React.ReactNode;
  className?: string;
};

export const SectionComplexView: React.FC<SectionComplexViewProps> = ({ title, children }) => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>{title}</p>
      {children}
    </div>
  );
};
